<template>
  <div class="content" v-loading="loading">
    <div class="line" style="align-items: center">
      <span class="label">文字消息通知：</span>
      <div style="flex:1">
        <el-input
          v-model="textData.show_content"
          style="width:400px"
          type="text"
        ></el-input>
      </div>

      <el-button type="primary" @click="onSaveSetting">保存设置</el-button>
    </div>
    <div class="line top">
      <span class="label">轮播图上传：</span>
      <div>
        <input
          type="file"
          style="display:none"
          ref="fileInput"
          @change="fileChange($event.target.files)"
          multiple
          accept="image/*"
        />
        <el-button size="small" type="primary" @click="onUploadClick"
          >上传文件</el-button
        >
        <div class="tip">
          最多上传4张，支持扩展名：png . jpg . jpeg...
        </div>
      </div>
    </div>

    <div class="line" v-if="imageList.length">
      <span class="label">已上传图片：</span>

      <div class="img-list">
        <div class="img-item" v-for="(item, index) in imageList" :key="index">
          <div class="image">
            <img
              :src="item.baseUrl || item.show_content"
              alt
              class="previewImg"
            />
            <div class="imgMask">
              <el-button
                size="mini"
                circle
                icon="el-icon-zoom-in"
                @click="preview(index)"
              ></el-button>
              <el-button
                size="mini"
                circle
                icon="el-icon-delete"
                @click="delImg(index)"
              ></el-button>
            </div>
          </div>
          <el-form
            class="form"
            :model="item"
            :rules="rules"
            label-width="100px"
          >
            <el-form-item class="form-line" label="展示排序：" prop="sort">
              <el-input
                v-model="item.sort"
                style="width:180px;"
                size="mini"
                min="0"
                type="number"
                placeholder="数值越大越靠前"
              ></el-input>
            </el-form-item>
            <el-form-item class="form-line" label="跳转链接：" prop="url_param">
              <el-input
                v-model="item.url_param"
                style="width:180px;"
                size="mini"
                type="text"
                placeholder="输入url"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getBannerList,
  insertBanner,
  updateBanner,
  deleteBanner
} from '@/api/setting'
import axios from 'axios'
import { qiniuToken } from '@/api/common'
axios.defaults.headers.common['Content-Type'] =
  'application/x-www-form-urlencoded'
axios.defaults.headers.common['Accept'] = '*/*'
const axiosInstance = axios.create({ withCredentials: false })
let baseMap = {}
const MAX = 4
export default {
  data() {
    return {
      rules: {
        url_param: [{ required: true, message: '请输入url', trigger: 'blur' }]
      },
      form: {
        page: 1,
        size: 20
      },
      textData: {
        id: null,
        show_content: ''
      },
      loading: false,
      // 最终的保存遍历集合，有id视为编辑，无id视为创建
      imageList: [
        // {
        //   id: 0,
        //   show_content: '',
        //   sort: 0,
        //   url_param: ''
        // }
      ],
      // 记录需要删除的ids
      deleteIds: [],
      error: false
    }
  },
  created() {
    getBannerList(2).then(res => {
      if (res.data && res.data.length) {
        this.textData.show_content = res.data[0].show_content
        this.textData.id = res.data[0].id
      }
    })
    getBannerList(1).then(res => {
      this.imageList = res.data
    })
  },
  methods: {
    fileChange(file) {
      let num = this.imageList.length
      if (file) {
        for (let index = 0; index < file.length; index++) {
          if (num >= MAX) {
            return
          }
          num++
          this.uploadFile(file[index])
        }
      }
    },
    onUploadClick() {
      let num = this.imageList.length
      if (num >= MAX) {
        this.$message.error('已达上传上限')
        return
      }
      this.$refs.fileInput.click()
    },
    onSaveSetting() {
      this.loading = true
      this.deleteBanners()
      this.modifyAndAdd()
    },
    /**
     * 批量删除banner
     */
    async deleteBanners() {
      for (let index = 0; index < this.deleteIds.length; index++) {
        const res = await deleteBanner({ id: this.deleteIds[index] })
        if (res.code !== 10000) {
          this.error = true
          this.$message.error(res.message)
        }
      }
    },
    /**
     * 批量编辑与添加banner
     */
    async modifyAndAdd() {
      for (let index = 0; index < this.imageList.length; index++) {
        const item = this.imageList[index]
        let form = {
          show_content: item.show_content,
          sort: item.sort,
          url_param: item.url_param
        }
        let res
        if (item.id) {
          res = await updateBanner(Object.assign(form, { id: item.id }))
        } else {
          res = await insertBanner(
            Object.assign(form, { show_type: 2, board_id: 1 })
          )
        }
        if (res.code !== 10000) {
          this.error = true
          this.$message.error(res.message)
        }
      }
      // 修改文字
      let res
      if (this.textData.id) {
        if (this.textData.show_content) {
          res = await updateBanner({
            show_content: this.textData.show_content,
            id: this.textData.id
          })
        } else {
          res = await deleteBanner({ id: this.textData.id })
        }
      } else if (this.textData.show_content) {
        res = await insertBanner({
          show_content: this.textData.show_content,
          board_id: 2,
          show_type: 1
        })
      }
      if (res && res.code !== 10000) {
        this.error = true
        this.$message.error(res.message)
      }

      this.loading = false
      this.deleteIds = []
      if (!this.error) {
        this.$message.success('保存成功！')
      }
    },
    /**
     * 上传图片
     */
    uploadFile(file) {
      if (file.size < 1100000) {
        const fileName = file.name
        const suffix = fileName
          .substring(fileName.lastIndexOf('.') + 1)
          .toUpperCase()
        if (
          suffix === 'BMP' ||
          suffix === 'JPG' ||
          suffix === 'JPEG' ||
          suffix === 'PNG' ||
          suffix === 'GIF'
        ) {
          this.loading = true

          qiniuToken({})
            .then(res => {
              const token = res.data.token
              const imgUrl = res.data.bind_url || res.data.url
              let data = new FormData()
              data.append('token', token) //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
              data.append('file', file)
              axiosInstance({
                method: 'POST',
                url: 'http://up-z1.qiniu.com/', //上传地址
                data: data,
                timeout: 30000 //超时时间，因为图片上传有可能需要很久
                // onUploadProgress: (progressEvent)=> {
                //     //imgLoadPercent 是上传进度，可以用来添加进度条
                //     let imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                //     console.log(imgLoadPercent)
                // },
              })
                .then(async data => {
                  this.loading = false
                  let uData = {
                    sort: 0,
                    url_param: ''
                  }
                  uData.show_content = imgUrl + '/' + data.data.key
                  console.log(34324, res)
                  if (process.env.NODE_ENV == 'development') {
                    uData.baseUrl = await this.getImgBase64(uData.show_content)
                  }
                  this.imageList.push(uData)

                  //上传成功...  (登录七牛账号，找到七牛给你的 URL地址) 和 data里面的key 拼接成图片下载地址
                })
                .catch(() => {
                  //上传失败
                  this.loading = false
                  this.$message.error('上传失败，请重新上传！')
                })
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          this.$message.error('文件类型不正确,请重新上传！')
        }
      } else {
        this.$message.error('图片大小超过1M,请重新上传')
      }
    },
    preview(index) {
      this.$alert(
        `<img src="${this.imageList[index].baseUrl ||
          this.imageList[index].show_content}" width="100%" alt="">`,
        '图片预览',
        { dangerouslyUseHTMLString: true, showConfirmButton: false }
      )
    },
    delImg(index) {
      const item = this.imageList[index]
      this.imageList.splice(index, 1)
      this.$refs.fileInput.value = '' //请空input
      if (item.id) {
        // 记录需要删除的id
        this.deleteIds.push(item.id)
      }
    },
    getImgBase64(url) {
      return new Promise((resolve, reject) => {
        if (baseMap[url]) {
          resolve(baseMap[url])
        } else {
          axiosInstance
            .get(
              'http://localhost:8444/getQiniuImg?url=' + encodeURIComponent(url)
            )
            .then(res => {
              baseMap[url] = 'data:image/png;base64,' + res.data
              resolve(baseMap[url])
            })
            .catch(() => {
              reject(url)
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 12px;
  .label {
    width: 100px;
    text-align: right;
  }
  .line {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;
    .center {
      flex: 1;
    }
    .tip {
      margin-top: 6px;
      color: #999;
      font-size: 12px;
    }
  }

  .img-list {
    .img-item {
      display: flex;
      align-items: center;
      &:not(:last-child) {
        margin-bottom: 12px;
      }
      .image {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        height: 100px;
        width: 100px;
        border-radius: 6px;
        border: 1px dashed #d9d9d9;
        position: relative;
        overflow: hidden;
        .previewImg {
          height: 100%;
          width: 100%;
        }
        .el-icon-loading {
          color: #fc501c;
        }
        .imgMask {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
          background: rgba(0, 0, 0, 0.3);
          opacity: 0;
          transition: opacity 0.5s;
          color: #fff;
          line-height: 1.5;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
        }
        &:hover {
          .imgMask {
            opacity: 1;
          }
        }
      }
      .form {
        margin-left: 12px;
        .form-line {
          display: block;
          &:first-child {
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
</style>
